module.exports = __webpack_public_path__ + "static/media/14a4e42043b696112919bfd1b6309b26.14a4e420.webp";